<template>
  <div>
    <PaymentCard />
  </div>
</template>

<script>
import PaymentCard from '@/components/Payment/Payment/Stripe/StripePaymentCard';

export default {
  name: 'Payment',
  components: { PaymentCard },
  setup() {

  },
};
</script>

<style scoped>

</style>
